// ── authError.js ────────────────────────────────────────────────────────────
// Shared auth-error copy used by BOTH the /login form and the logged-out landing
// (GuestHome) — the primary funnel. Kept in one place so the scrubber that protects
// /login can't drift out of sync with the marketing landing that most launch
// traffic actually hits (audit 2026-07-18: GuestHome was leaking raw strings).

// Never surface a raw auth/network error to the user — especially not the internal
// Supabase host. A dropped/blocked request (Safari's "Load failed", "Failed to
// fetch", NetworkError, a timeout) becomes a clear, retryable line instead of a
// scary URL.
export function friendlyAuthError(error) {
  const m = String(error?.message || '')
  if (/load failed|failed to fetch|network\s*error|networkerror|timeout|\.supabase\.co/i.test(m)) {
    return "Couldn't reach the server, check your connection and try again."
  }
  if (/invalid login credentials/i.test(m)) return 'That email and password don’t match.'
  if (/unable to validate email|invalid (email|format)/i.test(m)) return 'That doesn’t look like an email address.'
  if (/rate limit|too many/i.test(m)) return 'Too many tries. Give it a minute and try again.'
  return m || 'Something went wrong, please try again.'
}

// True ONLY when Supabase actually failed to SEND the confirmation/OTP email — not
// for any error whose text merely contains "email" (e.g. "Invalid email", "Email not
// confirmed"), which the old includes('email') check mis-triggered the send-failure
// copy on (audit 2026-07-18).
export function isEmailSendFailure(error) {
  return /error sending|sending.*(confirmation|email)|confirmation email/i.test(String(error?.message || ''))
}
